




































import { Component, Prop, Mixins } from 'vue-property-decorator';
import PermissionModal from './PermissionModal.vue';
import { IAllowancePromptConfig, StringKeyWithArgs } from '~/types/allowances';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import AuthQuery from '~/mixins/AuthQuery';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import grantArbitraryAllowance from '~/mutations/grantArbitraryAllowance.gql';

@Component({
  components: {
    PermissionModal,
    TwoFactorAuthInputPrompt,
  },
})
export default class AllowanceModal extends Mixins(AuthQuery) {
  @Prop(Boolean) showDialog!: boolean;
  @Prop(Function) onClosed!: Function;
  @Prop(Function) onSuccess!: Function;
  @Prop(Number) width!: number;
  @Prop(Object) allowancePromptConfig!: IAllowancePromptConfig;

  translate(str: StringKeyWithArgs) {
    return this.$t(str.stringKey, str.args);
  }

  async grantAllowance(transferCode: string) {
    await this.doAuthQuery(async (totpToken: string) => {
      await this.$apollo.mutate({
        mutation: grantArbitraryAllowance,
        variables: {
          grantee: this.allowancePromptConfig.grantee,
          transferCode,
          totpToken,
          allowance: {
            ...this.allowancePromptConfig.token,
            instance: '0',
            allowanceType: this.allowancePromptConfig.allowanceType,
            amount: this.allowancePromptConfig.allowanceAmount,
            uses: this.allowancePromptConfig.allowanceUses,
            expires: this.allowancePromptConfig.allowanceExpirationMsInFuture
              ? Date.now() +
                this.allowancePromptConfig.allowanceExpirationMsInFuture
              : undefined,
          },
        },
      });
    }, TwoFaCheckpoint.transactions);
  }

  onGrantSuccess(results: { transferCode: string }) {
    this.onSuccess(results);
  }
}
